export default __webpack_public_path__ + "static/media/qr1.5415ecf1.jpg";